import React from "react";

interface ImportFeedbackProps {
  message?: string;
  errors?: Array<{ row: number; message: string }>;
}

const ImportFeedback: React.FC<ImportFeedbackProps> = ({
  message,
  errors = [],
}) => {
  if (!message && errors.length === 0) return null;

  return (
    <div className="mb-3 space-y-1">
      {message && (
        <p className="text-sm text-green-600 dark:text-green-400">{message}</p>
      )}
      {errors.length > 0 && (
        <div className="text-sm text-red-600 dark:text-red-400 space-y-1">
          {errors.slice(0, 5).map((err, idx) => (
            <div key={`${err.row}-${idx}`}>
              Dòng {err.row}: {err.message}
            </div>
          ))}
          {errors.length > 5 && (
            <div>... và {errors.length - 5} lỗi khác</div>
          )}
        </div>
      )}
    </div>
  );
};

export default ImportFeedback;
